<template>
  <v-app id="dmsadmin">
    <router-view />
  </v-app>
  <!-- <v-app id="dmsadmin">
    <v-content>
      <d-header></d-header>
      <router-view />
    </v-content>
    <login v-else-if="routeStatus === 'notSignedIn'"></login>
  </v-app>-->
</template>

<script>
import { mapState } from 'vuex'

import DHeader from '@/components/common/Header'
import Login from '@/components/auth/Login'

export default {
  computed: {
    ...mapState('auth', ['profile'])
  },

  components: {
    DHeader,
    Login
  }
}
</script>



// WEBPACK FOOTER //
// src/App.vue